import * as React from 'react';
export var StepIndicator = function (_a) {
    var active = _a.active, _b = _a.mode, mode = _b === void 0 ? 'vertical' : _b, _c = _a.labels, labels = _c === void 0 ? [] : _c, children = _a.children;
    var stepperClass = mode === 'horizontal' ? 'stepper-horizontal' : 'stepper-vertical';
    var nodes = labels.map(function (child, index) { return (React.createElement("div", { className: "stepper-step", "data-active": active >= index, key: "panel-".concat(index) },
        React.createElement("span", { className: "stepper-preview" },
            React.createElement("span", { className: "stepper-indicator" },
                React.createElement("svg", { focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                    React.createElement("circle", { cx: "12", cy: "12", r: "12" }),
                    React.createElement("text", { x: "12", y: "16", "text-anchor": "middle" }, index + 1))),
            React.createElement("span", { className: "stepper-label" },
                React.createElement("span", null, child))),
        active === index && mode === 'vertical' && (React.createElement("div", { className: "stepper-content" },
            React.createElement("div", null, children))))); });
    for (var i = nodes.length; --i;) {
        var connector = (React.createElement("div", { className: "stepper-connector", key: "connector-".concat(i) },
            React.createElement("hr", null)));
        nodes.splice(i, 0, connector);
    }
    return React.createElement("div", { className: stepperClass }, nodes);
};
//# sourceMappingURL=index.js.map